import { render, staticRenderFns } from "./StainEdit.vue?vue&type=template&id=5bb73c2c&scoped=true&"
import script from "./StainEdit.vue?vue&type=script&lang=ts&"
export * from "./StainEdit.vue?vue&type=script&lang=ts&"
import style0 from "./StainEdit.vue?vue&type=style&index=0&id=5bb73c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb73c2c",
  null
  
)

export default component.exports